import { range } from 'lodash';
import React from 'react';
import { Th, Tr } from '../../../shared/Table';
import styled from 'styled-components/macro';

type Props = {
  numberOfPorts: number;
  portsRowWidths?: PortsRowWidths;
};

export type PortsRowWidths = {
  firstColumnWidth: number;
  firstActuatorColumnWidth: number;
  actuatorColumnWidth: number;
};

export const PortsRow = ({ numberOfPorts, portsRowWidths }: Props) => {
  return (
    <Tr>
      <OptionalWidthTh $width={portsRowWidths?.firstColumnWidth}>Port</OptionalWidthTh>
      {range(1, numberOfPorts + 1).map(portNumber => (
        <OptionalWidthTh
          key={portNumber}
          $width={portNumber === 1 ? portsRowWidths?.firstActuatorColumnWidth : portsRowWidths?.actuatorColumnWidth}
        >
          {portNumber}
        </OptionalWidthTh>
      ))}
    </Tr>
  );
};

const OptionalWidthTh = styled(Th)<{ $width?: number }>`
  ${({ $width }) => ($width ? `width: ${$width}px` : '')};
`;
